export default __webpack_public_path__ + "static/media/calendar.d5ac4b0a.svg";